import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/error-rounded.svg'


const _withScopeId = n => (_pushScopeId("data-v-4569867b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "div-page-content-desc" }
const _hoisted_4 = { id: "registering-title-h1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { id: "registering-descrption-sub" }
const _hoisted_7 = { class: "div-page-content-area" }
const _hoisted_8 = { id: "registering-subtitle-basic-h3" }
const _hoisted_9 = { class: "div-columns" }
const _hoisted_10 = { class: "div-registering-input-container" }
const _hoisted_11 = {
  id: "registering-firstname-input-label",
  class: "registering-row-label full-row-input",
  for: "registering-firstname-input"
}
const _hoisted_12 = ["placeholder", "disabled"]
const _hoisted_13 = { class: "div-registering-input-container" }
const _hoisted_14 = {
  id: "registering-lastname-input-label",
  class: "registering-row-label full-row-input",
  for: "registering-lastname-input"
}
const _hoisted_15 = ["placeholder", "disabled"]
const _hoisted_16 = { class: "div-registering-label-row-row" }
const _hoisted_17 = {
  class: "full-row-label",
  id: "registering-social-sec-num-input-label",
  for: "registering-social-sec-num-input"
}
const _hoisted_18 = { class: "div-registering-input-row" }
const _hoisted_19 = ["placeholder", "disabled"]
const _hoisted_20 = { class: "div-registering-label-row" }
const _hoisted_21 = {
  class: "full-row-label",
  id: "registering-telephone-input-label",
  for: "registering-telephone-input"
}
const _hoisted_22 = { class: "div-registering-input-row" }
const _hoisted_23 = ["placeholder", "disabled"]
const _hoisted_24 = { class: "div-registering-label-row" }
const _hoisted_25 = {
  class: "full-row-label",
  id: "registering-email-input-label",
  for: "registering-email-input"
}
const _hoisted_26 = { class: "div-registering-input-row" }
const _hoisted_27 = ["placeholder", "disabled"]
const _hoisted_28 = { class: "div-registering-label-row" }
const _hoisted_29 = {
  id: "registering-street-address-input-label",
  class: "full-row-label",
  for: "registering-street-address-input"
}
const _hoisted_30 = { class: "div-registering-input-row" }
const _hoisted_31 = ["placeholder", "disabled"]
const _hoisted_32 = { class: "div-columns" }
const _hoisted_33 = { class: "div-registering-input-container" }
const _hoisted_34 = {
  id: "registering-postal-code-input-label",
  class: "registering-row-label full-row-input",
  for: "registering-postal-code-input"
}
const _hoisted_35 = ["placeholder", "disabled"]
const _hoisted_36 = { class: "div-registering-input-container" }
const _hoisted_37 = {
  class: "registering-row-label full-row-input",
  id: "registering-post-office-input-label",
  for: "registering-post-office-input"
}
const _hoisted_38 = ["placeholder", "disabled"]
const _hoisted_39 = { class: "div-registering-label-row" }
const _hoisted_40 = {
  id: "registering-country-input-label",
  class: "full-row-label",
  for: "registering-country-input"
}
const _hoisted_41 = { class: "div-registering-input-row" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "div-registering-dropdown" }
const _hoisted_44 = { id: "p-after-selectable" }
const _hoisted_45 = { id: "registering-subtitle-important-h3" }
const _hoisted_46 = { id: "registering-subtitle-agreement-h3" }
const _hoisted_47 = { class: "div-checkbox-container" }
const _hoisted_48 = { class: "divCheckbox" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "divCheckbox" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "divCheckbox" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["href"]
const _hoisted_55 = {
  key: 1,
  class: "div-error-note"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redIconArea" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "error-icon",
    src: _imports_0
  })
], -1))
const _hoisted_57 = { class: "pErrorCheckbox" }
const _hoisted_58 = {
  key: 2,
  style: {"margin-bottom":"25px"}
}
const _hoisted_59 = { id: "registering-subtitle-finish-h3" }
const _hoisted_60 = {
  key: 3,
  class: "div-error-note"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redIconArea" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "filterRed",
    src: _imports_0
  })
], -1))
const _hoisted_62 = { class: "bodyErrorArea" }
const _hoisted_63 = { class: "two-button-container" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_alert_note = _resolveComponent("custom-alert-note")!
  const _component_custom_drop_down = _resolveComponent("custom-drop-down")!
  const _component_custom_spinner = _resolveComponent("custom-spinner")!

  return (_ctx.errorFromResponse !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_custom_alert_note, {
          title: _ctx.store.getters.translate('alert-registering-failed-title'),
          text: _ctx.store.getters.translate('alert-registering-failed-text'),
          subtext: _ctx.store.getters.translate('alert-registering-failed-subtext'),
          button: _ctx.store.getters.translate('generic-return'),
          onRedirect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorFromResponse = null))
        }, null, 8, ["title", "text", "subtext", "button"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.store.getters.translate("registering")), 1),
          _hoisted_5,
          _createElementVNode("sub", _hoisted_6, _toDisplayString(_ctx.store.getters.translate("registering-description")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.store.getters.translate("basic-info")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.store.getters.translate("firstname")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "registering-firstname-input",
                class: _normalizeClass(
              _ctx.getClasses(
                'firstName',
                'registering-row-input-disabled full-row-input'
              )
            ),
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstName) = $event)),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetErrorsAndSetFocus('firstName'))),
                placeholder: _ctx.getInputPlaceholder(),
                disabled: _ctx.userIdentified('firstName')
              }, null, 10, _hoisted_12), [
                [_vModelText, _ctx.firstName]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.store.getters.translate("lastname")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "registering-lastname-input",
                class: _normalizeClass(
              _ctx.getClasses(
                'lastName',
                'registering-row-input-disabled full-row-input'
              )
            ),
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastName) = $event)),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetErrorsAndSetFocus('lastName'))),
                placeholder: _ctx.getInputPlaceholder(),
                disabled: _ctx.userIdentified('lastName')
              }, null, 10, _hoisted_15), [
                [_vModelText, _ctx.lastName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.store.getters.translate("social-id")), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(
            _ctx.getClasses(
              'socialSecurityNumber',
              'registering-row-input-disabled full-row-input'
            )
          ),
              id: "registering-social-sec-num-input",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.socialSecurityNumber) = $event)),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetErrorsAndSetFocus('socialSecurityNumber'))),
              placeholder: _ctx.getInputPlaceholder(),
              disabled: _ctx.userIdentified('ssn')
            }, null, 10, _hoisted_19), [
              [_vModelText, _ctx.socialSecurityNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.store.getters.translate("phone-number")), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(_ctx.getClasses('telephoneNumber', 'full-row-input')),
              id: "registering-telephone-input",
              type: "tel",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telephoneNumber) = $event)),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetErrorsAndSetFocus('telephoneNumber'))),
              placeholder: _ctx.getInputPlaceholder(),
              disabled: _ctx.inProgress
            }, null, 10, _hoisted_23), [
              [_vModelText, _ctx.telephoneNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.store.getters.translate("email")), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(_ctx.getClasses('email', 'full-row-input')),
              id: "registering-email-input",
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event)),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetErrorsAndSetFocus('email'))),
              placeholder: _ctx.getInputPlaceholder(),
              disabled: _ctx.inProgress
            }, null, 10, _hoisted_27), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.store.getters.translate("street-address")), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(_ctx.getClasses('streetAddress', 'full-row-input')),
              id: "registering-street-address-input",
              type: "text",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.streetAddress) = $event)),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resetErrorsAndSetFocus('streetAddress'))),
              placeholder: _ctx.getInputPlaceholder(),
              disabled: _ctx.inProgress
            }, null, 10, _hoisted_31), [
              [_vModelText, _ctx.streetAddress]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.store.getters.translate("postal-code")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "registering-postal-code-input",
                class: _normalizeClass(_ctx.getClasses('postalCode', 'full-row-input')),
                type: "text",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.postalCode) = $event)),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetErrorsAndSetFocus('postalCode'))),
                placeholder: _ctx.getInputPlaceholder(),
                disabled: _ctx.inProgress
              }, null, 10, _hoisted_35), [
                [_vModelText, _ctx.postalCode]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.store.getters.translate("post-office")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "registering-post-office-input",
                class: _normalizeClass(_ctx.getClasses('postOffice', 'full-row-input')),
                type: "text",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.postOffice) = $event)),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.resetErrorsAndSetFocus('postOffice'))),
                placeholder: _ctx.getInputPlaceholder(),
                disabled: _ctx.inProgress
              }, null, 10, _hoisted_38), [
                [_vModelText, _ctx.postOffice]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.store.getters.translate("home-country")), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("input", {
              id: "registering-country-input",
              type: "text",
              class: _normalizeClass(["full-row-input", {
            'validation-error': _ctx.countryMismatch
          }]),
              disabled: "",
              value: _ctx.getCountryAsStringToFormLocal
            }, null, 10, _hoisted_42)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_custom_drop_down, {
              label: _ctx.getLabelForDropDown,
              "init-value": _ctx.getInitValueForDropDown,
              options: _ctx.getOptionsForDropDown,
              "selected-option": _ctx.getSelectedForDropDown,
              "selection-index": 1,
              onChange: _ctx.languageSelectionChanged
            }, null, 8, ["label", "init-value", "options", "selected-option", "onChange"])
          ]),
          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.store.getters.translate("country-and-language-initialization-text-2")), 1),
          _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.store.getters.translate("registering-important")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.store.getters.translate("registering-important-1")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.store.getters.translate("registering-important-2")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.store.getters.translate("registering-important-3")), 1),
          _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.store.getters.translate("registering-mark-agreement")), 1),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(_ctx.getClasses('checkedBasicInfo', 'checkbox')),
                id: "checkboxBasicInfo",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.checkedBasicInfo) = $event)),
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.resetErrorsAndSetFocus('checkedBasicInfo'))),
                disabled: _ctx.inProgress
              }, null, 10, _hoisted_49), [
                [_vModelCheckbox, _ctx.checkedBasicInfo]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: _ctx.checkedBasicInfo
            }]),
                for: "checkboxBasicInfo"
              }, _toDisplayString(_ctx.store.getters.translate("registering-agreement-basic")), 3)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(_ctx.getClasses('checkedPatientRegister', 'checkbox')),
                id: "checkboxPatientRegister",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.checkedPatientRegister) = $event)),
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.resetErrorsAndSetFocus('checkedPatientRegister'))),
                disabled: _ctx.inProgress
              }, null, 10, _hoisted_51), [
                [_vModelCheckbox, _ctx.checkedPatientRegister]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: _ctx.checkedPatientRegister
            }]),
                for: "checkboxPatientRegister"
              }, _toDisplayString(_ctx.store.getters.translate(
                "registering-agreement-saving-to-register"
              )), 3)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass(_ctx.getClasses('checkedTermsOfUse', 'checkbox')),
                id: "checkboxTermsOfUse",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.checkedTermsOfUse) = $event)),
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.resetErrorsAndSetFocus('checkedTermsOfUse'))),
                disabled: _ctx.inProgress
              }, null, 10, _hoisted_53), [
                [_vModelCheckbox, _ctx.checkedTermsOfUse]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: _ctx.checkedTermsOfUse
            }]),
                for: "checkboxTermsOfUse"
              }, _toDisplayString(_ctx.store.getters.translate("registering-agreement-terms-of-use")), 3)
            ])
          ]),
          (_ctx.getTermsOfUseLink())
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                id: "linkTermsOfUse",
                href: _ctx.getTermsOfUseLink(),
                target: "_blank"
              }, _toDisplayString(_ctx.store.getters.translate("registering-terms-of-use")), 9, _hoisted_54))
            : _createCommentVNode("", true),
          (_ctx.errorCheckbox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.store.getters.translate("accept-all-agreements")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_58)),
          _createElementVNode("h3", _hoisted_59, _toDisplayString(_ctx.store.getters.translate("registering-finish")), 1),
          (_ctx.errorGeneral)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.store.getters.translate("registering-form-error")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("button", {
              id: "registering-return-button",
              class: "buttonReturn",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.doReturn && _ctx.doReturn(...args)))
            }, _toDisplayString(_ctx.store.getters.translate("generic-return")), 1),
            (_ctx.store.getters.getConsent !== null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: _ctx.inProgress,
                  id: "registering-continue-button",
                  class: "buttonContinue",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.doContinue && _ctx.doContinue(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("generic-continue")), 9, _hoisted_64))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: _ctx.inProgress,
                  id: "registering-send-button",
                  class: "buttonContinue",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.agreeAndSend && _ctx.agreeAndSend(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("agree-and-send")), 9, _hoisted_65))
          ]),
          _createVNode(_component_custom_spinner, { loading: _ctx.inProgress }, null, 8, ["loading"])
        ])
      ]))
}